import {Filter} from '@shared/models/filter.model';
import {Utilities} from '@shared/utilities/utilities.model';

export class ThreadsFilter extends Filter {
	commodity_id: string;
	ald_commodity_id: string;
	ald_order_id: string;
	readers: string;
	from: string;
	to: string;
	subject: string;
	text: string;
	meta: string;
	flags: string;
	tags: string;
	module: string;
	has_attachments: boolean;
	is_read: boolean;
	is_deleted: boolean = false;
	super_user_commodity_ids: string[];
	is_sent: boolean;

	constructor(model?: any) {
		super();
		if (model) {
			this.commodity_id = model.commodity_id;
			this.ald_commodity_id = model.ald_commodity_id;
			this.ald_order_id = model.ald_order_id;
			this.readers = model.readers;
			this.from = model.from;
			this.to = model.to;
			this.subject = model.subject;
			this.text = model.text;
			this.meta = model.meta;
			this.flags = model.flags;
			this.tags = model.tags;
			this.module = model.module;
			this.has_attachments = model.has_attachments;
			this.is_deleted = !!model.is_deleted ? model.is_deleted : false;
			this.page = model.page;
			this.page_size = model.page_size;
			this.order_by = model.order_by;
			this.asc = model.asc;
			this.is_read = model.is_read;
			this.super_user_commodity_ids = [];
			if (model.super_user_commodity_ids) {
				model.super_user_commodity_ids.forEach( id => this.super_user_commodity_ids.push(id));
			}
			this.is_sent = model.is_sent;
		}
	}

	clone(): ThreadsFilter {
		return new ThreadsFilter(this);
	}

	getFilterUrl(): string {
		let filterUrl: string = Utilities.getQuery(this);
		if (!Utilities.isVoid(this.from) && Utilities.isVoid(this.to)) {
			filterUrl += '&created_to=31/12/2099';
		}
		if (!Utilities.isVoid(this.to) && Utilities.isVoid(this.from)) {
			filterUrl += '&created_from=01/01/1900';
		}
		return filterUrl;
	}

	newFilter(model?: any): Filter {
		return new ThreadsFilter(model);
	}
}
